import api from "../api/Client";

export type ProfessionalReservationClient = {
  id: number;
  name: string;
  bookingId: number;
  isVip: boolean;
  trainingFactor: string | number | null;
  hasDocuments: boolean;
  isRecent: boolean;
  comment: string;
  questionnaireStatus: string | null;
  late: boolean;
  absent: boolean;
};

export type ProfessionalReservationSlot = {
  id: string;
  time: string;
  count: number;
  label?: string;
  clients: ProfessionalReservationClient[];
};

export async function fetchProfessionalReservationSlots(params: {
  date: string;
  shift: "morning" | "afternoon";
}) {
  const response = await api.get("/api/professionals/reservations/slots", {
    params
  });

  const slots = Array.isArray(response.data?.slots) ? response.data.slots : [];
  return slots as ProfessionalReservationSlot[];
}

export async function updateProfessionalReservationComment(bookingId: number, comment: string) {
  await api.patch(`/api/professionals/reservations/${bookingId}/comment`, { comment });
}

export async function updateProfessionalReservationLate(bookingId: number, value: boolean) {
  await api.patch(`/api/professionals/reservations/${bookingId}/late`, { value });
}

export async function updateProfessionalReservationAbsent(bookingId: number, value: boolean) {
  await api.patch(`/api/professionals/reservations/${bookingId}/absent`, { value });
}
